var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgWork2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#58F2A9",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.222 18.83C14.118 18.0553 14.8227 17.4207 15.336 16.926C15.8587 16.422 16.2927 15.8993 16.638 15.358C16.9833 14.8167 17.156 14.2753 17.156 13.734C17.156 13.174 17.0207 12.7353 16.75 12.418C16.4887 12.1007 16.0733 11.942 15.504 11.942C14.9533 11.942 14.524 12.1193 14.216 12.474C13.9173 12.8193 13.7587 13.286 13.74 13.874H12.2C12.228 12.81 12.5453 11.998 13.152 11.438C13.768 10.8687 14.5473 10.584 15.49 10.584C16.5073 10.584 17.3007 10.864 17.87 11.424C18.4487 11.984 18.738 12.7307 18.738 13.664C18.738 14.336 18.5653 14.9847 18.22 15.61C17.884 16.226 17.478 16.7813 17.002 17.276C16.5353 17.7613 15.938 18.326 15.21 18.97L14.58 19.53H19.018V20.86H12.214V19.698L13.222 18.83Z",
    fill: "#1ED760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork2);
export default __webpack_public_path__ + "static/media/work2.c59979290a399d820aa340dd2c3596ac.svg";
export { ForwardRef as ReactComponent };